import { render, staticRenderFns } from "./Toasts.vue?vue&type=template&id=59c14148"
import script from "./Toasts.vue?vue&type=script&lang=js"
export * from "./Toasts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Toasts.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59c14148')) {
      api.createRecord('59c14148', component.options)
    } else {
      api.reload('59c14148', component.options)
    }
    module.hot.accept("./Toasts.vue?vue&type=template&id=59c14148", function () {
      api.rerender('59c14148', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Toasts.vue"
export default component.exports